<template>
<div class="popup" v-show="syncMultiShow" v-cloak id="syncMulti">
    <div id="transferAim" class="content">
        <div class="title">
            <span>{{$t('language.popup.cloudTransferPopup.pleaSelect')}}</span>
            <div class="icon white-close dialog-close" @click="closeTreeDialog()"></div>
        </div>
        <!-- <div v-if="realTimeMode" class="realTime-title">{{$t('language.cloudSync.servicesSu')}}
            <div class="icon-util question-mark question-position">
                <div class="prompt-realtime-tip">{{$t('language.cloudSync.egDrives')}}</div>
            </div>
        </div> -->
        <div class='task-content' v-loading='loading' id="taskContent" ref="aimTree">
           <el-scrollbar style="height:100%;" ref="elscrollbar">
               <div v-if="!model.length&&!loading" class='real-nodrives'  @click="toAddCloudPage()">
               <div class="nondrive-realtime"></div>
                <div class="nondrive-realtimedes" v-if="realTimeMode">
                    {{$t('language.cloudSync.addRealDrives')}}
               </div>
               <div class="nondrive-realtimedes" v-else>
                    {{$t('language.popup.cloudTransferPopup.addValidCloud')}}
               </div>

                </div>
            <div id="treeNodes">
            <ul :key=index v-for="(item,index) in model">
                <tree ref="tree" :model="item" :index=index :treeShow=true :transferAimFlag=transferAimFlag></tree>
            </ul>
            </div>
            </el-scrollbar>
        </div>
        <div class="task-footer">
            <div v-if="!toWayShow && !realTimeMode" >
                <div class="icon-util nocheck move-position" :class="[$store.state.syncMultiSelect==true?'check':'']" @click="multi($event)"></div>
                <div class="multi-select">{{$t('language.common.multiSelect')}}</div>
            </div>
            <button class="task-button" @click.stop="syncAimSubmit()">{{$t('language.common.ok')}}</button>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import tree from '@/components/common/trees/tree';
import requestUtils from '@/js/request_util.js';
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
import '@/assets/css/tree.css';
import commonstate from '@/js/constant.js';
export default {
    components: {
        tree
    },
    data: function () {
        return {
            syncMultiShow: false,
            model: [],
            sourceIndex: -1,
            aimIndex: -1,
            tid: null,
            transferAimFlag: 'syncAim',
            oBox: null,
            ev: null,
            oDiv: null,
            x1: null,
            y1: null,
            x2: null,
            y2: null,
            left: null,
            top: null,
            width: null,
            height: null,
            toWayShow: false,
            checkedNodes: [],
            loading: true,
            flag: true,
            scrollTopValue: 0,
            realTimeMode:false
        }
    },
    inject: ["reload"],
    mounted() {
        let that = this;
        let models = Object.assign([], this.$store.getters.getUsersDrives);
        if (!models.length&&that.$route.name == 'cloudSync') {
            this.model = this.Utils.getAllCloudsList(function (res) {
                if (res.status == 200) {
                    //不需要邮箱
                    that.model = that.model.filter(cloud => !commonstate.emailClouds.includes(cloud.driveType));
                    that.loading = false;
                }
            });
        } else {
            //不需要邮箱
            models = models.filter(cloud => !commonstate.emailClouds.includes(cloud.driveType));
            this.model = models;
            that.loading = false;
        }
        $.each(this.model, function (index, item) {
            if (item.children && item.children.length) {
                item.open = false;
                delete item.children;
            }
        });
        this.$store.commit("setSyncMultiSelect", false);
        this.$store.commit('setDragFlage', false);
        this.$store.commit('setChildrenFlag', true);
    },
    watch:{
        syncMultiShow(newValue,oldValue){
       if(this.realTimeMode){
             this.$store.state.syncMultiSelect=false;
       }
      }
    },
    methods: {
        toAddCloudPage() {
            let dom;
            let that = this;
            $.each(that.$parent.$parent.$children, function (i, item) {
                if (item.menuOptions) {
                    dom = that.$parent.$parent.$children[i];
                    dom.menuOptionSelect(10);
                    return;
                }
            });
        },
        //用户执行多选的复制操作
        multi(event) {
            if (this.$store.state.syncMultiSelect == true) {
                this.$store.commit('setSyncMultiSelect', false);
                this.$store.commit('setSyncArrEmpty', []);
                let treeNodes = document.getElementsByClassName('tr-click');
                let length = treeNodes.length;
                for (let i = 0; i < treeNodes.length;) {
                    treeNodes[0].classList.remove("tr-click");
                }
            } else {
                this.$store.commit('setSyncMultiSelect', true);
                this.$store.commit('setTreeMoveSelect', false);
                this.$store.commit('setDragFlage', false);
                this.$store.commit('setChildrenFlag', true);
            }
        },
        //关闭树形组件
        closeTreeDialog() {
            if (!this.$store.state.syncArr.length || !this.$parent.mulitDrives.length) {
                $.each(this.model, function (index, item) {
                    item.open = false;
                    if (item.children && item.children.length) {
                        commonUtils.closeTree(item.children);
                    }
                });
                this.scrollTopValue = 0;
            } else {
                this.scrollTopValue = this.$refs.aimTree.scrollTop;
                this.$refs.aimTree.scrollTop = 0;
            }
            this.$store.commit('setSyncClickItem', -1);
            this.$store.commit('setTreeMoveSelect', false);
            this.syncMultiShow = false;
        },
        //同步目标提交
        syncAimSubmit() {
            let nodes = [];
            let that = this;
            let flag = true;
            let user = JSON.parse(localStorage.getItem("user"));
            nodes = this.$store.state.syncArr;
             if (!this.$store.state.isTreeflage) {//如果云盘正在创建不能提交
                return;
             }
            if (!user.vip && nodes.length > 1) {
                this.$parent.$refs.upgradeDialog.upgradeShow = true;
                this.$parent.$refs.upgradeDialog.reset();
                this.$parent.$refs.upgradeDialog.syncMultShow = true;
                return false;
            }
            // console.log(nodes);
            // if(this.realTimeMode && user.vip && nodes.length>2 && !this.$parent.$refs.realTimeNoticeDialog.isSure){
            //           this.$parent.$refs.realTimeNoticeDialog.noticeShow=true;
            //           return false;
            // }
            //this.$parent.$refs.realTimeNoticeDialog.isSure=false;
            let sourcesNode = this.$parent.singleDrives;
            let sourceCatalogArr = [];
            let pKey;

            for (let i = 0; i < nodes.length; i++) {
                let pathArray = taskTransferUtils.findFilePathArray(this.model, nodes[i], []);
                let path = pathArray[0];
                for (let j = 1; j < pathArray.length; j++) {
                    path = path + '\\' + pathArray[j];
                }
                nodes[i].formUrl = path;
            }
            if (nodes.length && sourcesNode.cloudCatalog) {
                if (sourcesNode.driveId) {
                    pKey = sourcesNode.driveId + sourcesNode.id + sourcesNode.formUrl;
                } else if (sourcesNode.rootId) {
                    pKey = sourcesNode.id + sourcesNode.rootId + sourcesNode.name;
                }
                sourceCatalogArr.push(pKey);
                $.each(nodes, function (index, item) {
                    that.flag = taskTransferUtils.checkCatalog(sourceCatalogArr, item);
                    if (that.flag == false) {
                        that.$toast({
                            text: that.$t('language.exception.notBeTheSame'),
                            type: 'fail',
                            idValue: "syncMulti",
                            learnMoreShow: true
                        });
                        return false;
                    }
                });
            }

            if (this.flag) {
                this.checkedNodes = nodes;
                if (nodes.length > 1) {
                    this.$parent.hasSelectItemsMore = true;
                    this.$parent.mulitDrives = Object.assign([], nodes);
                    this.$parent.hasSelectItems = false;
                } else if (nodes.length == 1) {
                    this.$parent.mulitDrives = Object.assign([], nodes);
                    this.$parent.hasSelectItems = true;
                    this.$parent.hasSelectItemsMore = false;
                } else if (nodes.length == 0) {
                    this.$parent.mulitDrives = [];
                    this.$parent.hasSelectItems = false;
                    this.$parent.hasSelectItemsMore = false;
                }
                this.syncMultiShow = false;
            }
            
            this.scrollTopValue = this.$refs.aimTree.scrollTop;
            this.$refs.aimTree.scrollTop = 0;
        }
    }
}
</script>

<style>
#transferAim {
    width: 500px;
    /*no*/
    height: 500px;
    /*no*/
}

.el-scrollbar .el-scrollbar__wrap {
    overflow-x: hidden;
}

.aimTreeTip {
    font-size: 14px;
    /*no*/
    float: left;
    width: 100%;
    /*no*/
    line-height: 20px;
    /*no*/
    margin-left: 20px;
    /*no*/

}


</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_transfer_popups/sync_multi_popup.vue